var playerVimeo = {}, playerYoutube = {};

function getVimeoPlayer(id) {
	return $('<iframe id="modal-vid-'+id+'" frameborder="0" allowfullscreen="1" title="Vimeo video player" width="640" height="360" src="https://player.vimeo.com/video/'+id+'?api=1"></iframe>');
}

function scrollToDiv(element, offset){$('html,body').unbind().animate({scrollTop:$(element).offset().top-offset},'slow');}


function canPlayVideo(video) {
	var canPlay = ($(video).get(0).canPlayType('video/mp4') != ''
		|| $(video).get(0).canPlayType('video/webm') != '');

	var i = 0,
	iDevice = ['iPad', 'iPhone', 'iPod'];
	for ( ; i < iDevice.length ; i++ ) {
		if( navigator.platform === iDevice[i] ) {
			canPlay = false; break;
		}
	}
	return canPlay;
}

jQuery(document).ready(function ($) {

	// FOR VIDEOS THAT WILL POP INTO MODAL
	if($('.modal').length) {
		$('.modal').on('shown.bs.modal', function () {
			// CMS pages use class youtube-modal-video
			var video = $(this).find('.youtube-modal-video');
			if(video.length) {
				var dataVideo = video.data('video');
				if (/^\d+$/.test(dataVideo)) {
					var iframeVimeo = getVimeoPlayer(dataVideo);
					video.after(iframeVimeo);
					video.remove();
					playerVimeo[dataVideo] = $f(iframeVimeo[0]);
				} else {
                  	var id = video.attr('id');
					playerYoutube[id] = new YT.Player(id, {
						videoId: dataVideo,
						enablejsapi: 1,
						origin: document.location.origin
					});
				}
			}

			// product pages use class youtube-video
			var video = $(this).find('.youtube-video');
			if(video.length) {
				var dataVideo = video.data('video');
				if (/^\d+$/.test(dataVideo)) {
					var iframeVimeo = getVimeoPlayer(dataVideo);
					video.after(iframeVimeo);
					video.remove();
					playerVimeo[dataVideo] = $f(iframeVimeo[0]);
				} else {
                  	var id = video.attr('id');
					playerYoutube[id] = new YT.Player(id, {
						videoId: dataVideo,
						enablejsapi: 1,
						origin: document.location.origin
					});
				}
			}
		});
		$('.modal').on('hidden.bs.modal', function() {
			$(this).find('.close').click();
			for (var i in playerVimeo) {
				pauseVimeoVideo(i);
			}
          	for (var i in playerYoutube) {
				pauseYoutubeVideo(i);
			}
		});
	}
  
    if($('.carousel').length) {
		$('.carousel').each(function() {
			var items_lg        = 4;
			var items_md        = 4;
			var items_sm        = 1;
			var items_xs        = 1;
			var autoplay        = false;
			var stoponhover     = true;
			var navigationOn    = false;
			var paginationOn    = true;
			var mouseDragOn     = true;
			var touchDragOn     = true;
			var navRewind       = true;
			var afterInitFunc   = false;
			var afterActionFunc = false;

			if(typeof $(this).data('items_lg') != 'undefined') {
				items_lg = $(this).data('items_lg');
			}
			if(typeof $(this).data('items_md') != 'undefined') {
				items_md = $(this).data('items_md');
			}
			if(typeof $(this).data('items_sm') != 'undefined') {
				items_sm = $(this).data('items_sm');
			}
			if(typeof $(this).data('items_xs') != 'undefined') {
				items_xs = $(this).data('items_xs');
			}
			if(typeof $(this).data('autoplay') != 'undefined') {
				autoplay = $(this).data('autoplay');
			}
			if(typeof $(this).data('stoponhover') != 'undefined') {
				stoponhover = $(this).data('stoponhover');
			}
			if(typeof $(this).data('navigation') != 'undefined') {
				navigationOn = $(this).data('navigation');
			}
			if(typeof $(this).data('pagination') != 'undefined') {
				paginationOn = $(this).data('pagination');
			}
			if(typeof $(this).data('mouse_drag') != 'undefined') {
				mouseDragOn = $(this).data('mouse_drag');
			}
			if(typeof $(this).data('touch_drag') != 'undefined') {
				touchDragOn = $(this).data('touch_drag');
			}
			if(typeof $(this).data('rewind_nav') != 'undefined') {
				navRewind = $(this).data('rewind_nav');
			}
			if(typeof $(this).data('rewind_nav') != 'undefined') {
				navRewind = $(this).data('rewind_nav');
			}
			if(typeof $(this).data('after_init') != 'undefined') {
				var fn = window[$(this).data('after_init')];
				if(typeof fn === 'function') {
					afterInitFunc = fn;
				}
			}
			if(typeof $(this).data('after_action') != 'undefined') {
				var fn = window[$(this).data('after_action')];
				if(typeof fn === 'function') {
					afterActionFunc = fn;
				}
			}

			$(this).owlCarousel({
				items : items_lg,
				itemsDesktop : [1199,items_lg],
				itemsDesktopSmall : [1024,items_md],
				itemsTablet: [976,items_sm],
				itemsMobile : [479,items_xs],
				autoPlay : autoplay,
				stopOnHover : stoponhover,
				lazyLoad : true,
				navigation : navigationOn,
				navigationText : false,
				pagination : paginationOn,
				mouseDrag : mouseDragOn,
				touchDrag : touchDragOn,
				rewindNav: false,
				afterInit: afterInitFunc,
				afterAction: afterActionFunc,
				rewindNav: true
			});
		});
	  }
});

$(window).load(function() {

	// Load the IFrame Player API code asynchronously.
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	var player;

	if($('video').length) {
		$('video').each(function() {
			if(canPlayVideo(this)) {
				$('.video-placeholder.visible-md.visible-lg').removeClass('visible-md').removeClass('visible-lg').addClass('hidden');
				$(this).removeClass('hidden');
				if(typeof $(this).data('autoplay') == 'undefined' || (typeof $(this).data('autoplay') != 'undefined') && $(this).data('autoplay')) {
					if (typeof $(this).get(0).loop == 'boolean') {
						$(this).get(0).loop = true;
					} else {
						$(this).on('ended', function () {
							$(this).get(0).currentTime = 0;
							$(this).get(0).play();
							}, false
						);
					}
				}
			} else {
				// remove video div
			}
		});
		$('video').each(function() {
			if(typeof $(this).data('autoplay') == 'undefined' || (typeof $(this).data('autoplay') != 'undefined') && $(this).data('autoplay')) {
				$(this).get(0).play()
			}
		});
	}
});

function onYouTubePlayerAPIReady() {
	if($('.youtube-video').length) {
		$('.youtube-video').each(function() {
			if(!$(this).parents('.modal-body').length) {
				var dataVideo = $(this).data('video');
				if (/^\d+$/.test(dataVideo)) {
					var iframeVimeo = getVimeoPlayer(dataVideo);
					$(this).after(iframeVimeo);
					$(this).remove();
					playerVimeo[dataVideo] = $f(iframeVimeo[0]);
				} else {
					player = new YT.Player($(this).attr('id'), {
						videoId: dataVideo,
						enablejsapi: 1,
						origin: document.location.origin
					});
				}
			}
		});
	}
}

function pauseYoutubeVideo(id) {
	var iframe = $("#"+id);
	if(iframe.length > 0 && typeof iframe[0].contentWindow != 'undefined') {
		iframe[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	}
}

function pauseVimeoVideo(id) {
	if (typeof playerVimeo[id] !== "undefined") {
		playerVimeo[id].api("pause");
	}
}

function isLocalStorageSupported() {
	try {
		return 'localStorage' in window && window['localStorage'] !== null;
	} catch(e){
		return false;
	}
}

function getTimestamp() {
	return Math.round(new Date().getTime() / 1000)
}

